
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function PunetoAurangabadcabbooking() {



    const cardData =
    {
        keyword: 'Pune To Aurangabad Cab Booking',
        heading: 'Mauli Cabs: Pune To Aurangabad Cab Booking',
        headingDescription: 'Mauli Cabs offers convenient and reliable Pune to Aurangabad cab booking services, ensuring a comfortable and safe journey to this historic city. Whether you are visiting for cultural exploration, business, or a family trip, we offer a variety of vehicles including sedans, SUVs, and premium cars to suit your needs. With professional drivers, transparent pricing, no hidden charges, and a focus on customer satisfaction, Mauli Cabs guarantees a smooth and enjoyable ride from Pune to Aurangabad.',

        top: 'Top Places to Visit in Aurangabad with Mauli Cabs',

"topPlaces": [
    {
        "title": "Ajanta Caves",
        "description": "Ajanta Caves, located near Aurangabad, are a UNESCO World Heritage Site known for their exquisite murals and sculptures. These caves, carved into the rock, depict the life of Lord Buddha and are an architectural marvel of ancient India."
    },
    {
        "title": "Ellora Caves",
        "description": "Ellora Caves, also a UNESCO World Heritage Site, showcase a remarkable blend of Hindu, Buddhist, and Jain temples carved into the rock. The Kailasa Temple in Ellora is especially renowned for its monolithic structure and intricate carvings."
    },
    {
        "title": "Bibi Ka Maqbara",
        "description": "Often referred to as the 'Taj of the Deccan,' Bibi Ka Maqbara is a stunning mausoleum built in the Mughal architectural style. It is dedicated to the memory of Aurangzeb’s wife, Rabia Durrani, and is one of the main attractions in Aurangabad."
    },
    {
        "title": "Daulatabad Fort",
        "description": "Daulatabad Fort, also known as Devgiri Fort, is an imposing fortress located just outside Aurangabad. The fort offers breathtaking views and an exciting climb, along with historical significance as the capital of the Yadava dynasty."
    },
    {
        "title": "Grishneshwar Temple",
        "description": "Grishneshwar Temple is an important Hindu pilgrimage site located near Ellora. It is one of the 12 Jyotirlingas dedicated to Lord Shiva and is renowned for its spiritual significance and architectural beauty."
    },
    {
        "title": "Aurangabad Caves",
        "description": "Aurangabad Caves are a group of 12 rock-cut Buddhist shrines that date back to the 6th and 7th centuries. They are famous for their carvings of Buddhist deities and for their peaceful and serene surroundings."
    },
    {
        "title": "Jama Masjid",
        "description": "Jama Masjid is one of the oldest mosques in Aurangabad, showcasing beautiful Mughal architecture. The mosque is known for its peaceful ambiance and is a must-visit for those interested in history and architecture."
    },
    {
        "title": "Nahar (Tiger) Waterfall",
        "description": "Nahar Waterfall, located near Aurangabad, is a popular spot for nature lovers and photographers. It offers a serene setting and is perfect for a relaxing day surrounded by natural beauty."
    },
    {
        "title": "Panchakki",
        "description": "Panchakki is a historic water mill and a significant landmark in Aurangabad. It was built in the 17th century to harness water for milling grains. The site is now a place of historical and architectural interest."
    },
    {
        "title": "Chand Minar",
        "description": "Chand Minar, located in Daulatabad Fort, is a tall minaret that offers panoramic views of the surrounding landscape. The tower is a significant historical and architectural feature of the fort."
    }
],

"services": [
    {
        "name": "Pune to Aurangabad Cab Service",
        "description": "Mauli Cabs offers reliable and comfortable cab services from Pune to Aurangabad. Enjoy a smooth and hassle-free journey with our well-maintained vehicles and professional drivers."
    },
    {
        "name": "Book Pune to Aurangabad Taxi",
        "description": "Book your taxi from Pune to Aurangabad with Mauli Cabs. We offer easy online booking and a variety of vehicles to choose from for a comfortable and safe journey."
    },
    {
        "name": "Affordable Pune to Aurangabad Cab",
        "description": "Mauli Cabs provides affordable cab services from Pune to Aurangabad without compromising on comfort or quality. Travel with ease and save with our competitive rates."
    },
    {
        "name": "Private Taxi for Aurangabad from Pune",
        "description": "Travel privately from Pune to Aurangabad with Mauli Cabs. Our private taxi services ensure a personalized and comfortable experience for your trip."
    },
    {
        "name": "Aurangabad Trip by Cab from Pune",
        "description": "Mauli Cabs provides convenient and comfortable cab services for your trip from Pune to Aurangabad. Explore the historical sites and attractions in Aurangabad with a professional driver."
    },
    {
        "name": "Pune to Aurangabad One-Way or Round Trip",
        "description": "Mauli Cabs offers both one-way and round-trip taxi options for your Pune to Aurangabad journey. Choose the service that best fits your schedule and travel needs."
    },
    {
        "name": "Comfortable Taxi Ride to Aurangabad",
        "description": "Enjoy a comfortable taxi ride from Pune to Aurangabad with Mauli Cabs. Our vehicles are air-conditioned, spacious, and well-maintained to ensure your comfort throughout the journey."
    },
    {
        "name": "Group Travel to Aurangabad",
        "description": "Mauli Cabs offers spacious vehicles for group travel to Aurangabad. Whether you're traveling with family or friends, we ensure a comfortable and enjoyable journey for all."
    },
    {
        "name": "Luxury Taxi for Aurangabad Trip",
        "description": "Travel in luxury from Pune to Aurangabad with Mauli Cabs' premium taxi services. Enjoy a plush and stylish ride with high-end amenities and excellent customer service."
    },
    {
        "name": "Aurangabad Sightseeing by Taxi",
        "description": "Explore the historical and cultural landmarks of Aurangabad with Mauli Cabs' sightseeing services. Our professional drivers will guide you to top attractions like Ellora Caves, Ajanta Caves, and more."
    }
],

"tableData": [
    ["Pune to Aurangabad Cab Service", "Book Pune to Aurangabad Taxi"],
    ["Affordable Pune to Aurangabad Cab", "Private Taxi for Aurangabad from Pune"],
    ["Aurangabad Trip by Cab from Pune", "Pune to Aurangabad One-Way or Round Trip"],
    ["Comfortable Taxi Ride to Aurangabad", "Group Travel to Aurangabad"],
    ["Luxury Taxi for Aurangabad Trip", "Aurangabad Sightseeing by Taxi"]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs offers reliable and punctual service for your Pune to Aurangabad trip. Whether you're visiting for business, leisure, or exploring historical sites, our drivers ensure timely pickups and drop-offs, making sure you reach your destination on time."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We provide a variety of vehicles for your Pune to Aurangabad journey, including sedans, SUVs, and premium cars. All vehicles are air-conditioned, well-maintained, and offer ample space, ensuring a comfortable and pleasant ride."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced and professional drivers are familiar with the Pune to Aurangabad route. They ensure a smooth, safe, and efficient journey, following the best routes and traffic patterns to provide a hassle-free experience."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers affordable pricing for your Pune to Aurangabad Cab Booking. We ensure transparent pricing with no hidden charges, so you can enjoy your journey without any surprises along the way."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Safety is our top priority. All our vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers adhere to strict safety protocols to ensure your journey from Pune to Aurangabad is both secure and comfortable."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Aurangabad Cab Booking. Whether you need an early morning pickup or a late-night return, our customer service team is ready to assist you with flexible booking options at any time."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Aurangabad cab with Mauli Cabs is quick and easy. You can book online through our website or mobile app, or reach out to our customer service team for personalized assistance to make your journey even smoother."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Aurangabad trip. Whether you’re visiting the Ajanta and Ellora caves or exploring other historical landmarks, we can tailor your trip to meet your preferences and needs."
    }
]














    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Aurangabad with Mauli Cabs?',
            answer: 'Booking your cab for Aurangabad is easy! You can book directly through our website or mobile app. Simply enter Pune as your pickup location and Aurangabad as your destination, then choose your preferred vehicle. Alternatively, you can call our support team for booking assistance.',
        },
        {
            question: 'What types of cabs are available for the Pune to Aurangabad trip?',
            answer: 'Mauli Cabs offers a variety of vehicles for your trip to Aurangabad, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. You can select the vehicle based on your comfort, group size, and budget for the journey.',
        },
        {
            question: 'Is the fare for the Pune to Aurangabad trip fixed?',
            answer: 'Yes, the fare is fixed and transparent. It includes all necessary charges such as tolls, taxes, and driver fees, ensuring no hidden costs. You’ll receive the total fare upfront before confirming your booking.',
        },
        {
            question: 'How long does the journey from Pune to Aurangabad take?',
            answer: 'The journey from Pune to Aurangabad typically takes around 5 to 6 hours, depending on traffic conditions. Our drivers ensure that you enjoy a smooth and timely journey throughout.',
        },
        {
            question: 'Are the drivers experienced with the Pune to Aurangabad route?',
            answer: 'Yes, Mauli Cabs drivers are well-experienced and familiar with the best routes to Aurangabad. They ensure a safe, efficient, and comfortable ride.',
        },
        {
            question: 'Can I book a round trip from Pune to Aurangabad?',
            answer: 'Yes, you can easily book a round-trip ride. Just provide your return details while booking, and we will handle the rest for you.',
        },
        {
            question: 'Can I make sightseeing stops along the way to Aurangabad?',
            answer: 'Yes, we can customize your journey by making stops for sightseeing along the way. You can visit attractions or take breaks as you like during the journey to make it more enjoyable.',
        },
        {
            question: 'Are the cabs air-conditioned and comfortable?',
            answer: 'Yes, all of our cabs are fully air-conditioned and maintained for cleanliness and comfort. We ensure a pleasant and comfortable ride throughout the journey to Aurangabad.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can easily cancel or modify your booking. We offer a flexible cancellation policy through our website or app, and our customer support team is always available to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Aurangabad trip?',
            answer: 'Mauli Cabs offers competitive pricing, a range of vehicle options, professional drivers, and flexible itineraries. We ensure a smooth, comfortable, and hassle-free trip to Aurangabad for business or leisure.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Prakash Patil",
            position: "Cultural Enthusiast",
            text: "Our trip to Aurangabad was amazing! The driver was very professional and well-versed with the route. The car was comfortable and well-maintained. We enjoyed our visit to the Ellora caves and other historical sites. Highly recommend Mauli Cabs for your travel needs!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Kavita Joshi",
            position: "History Buff",
            text: "I had an excellent experience with Mauli Cabs on my trip to Aurangabad. The cab was comfortable, the driver was polite, and the journey was smooth. The historical sites, including Ajanta and Ellora caves, were breathtaking. A wonderful trip overall!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Aurangabad Cab Booking by Mauli Cabs",
        "description": "Mauli Cabs offers affordable and comfortable cab services from Pune to Aurangabad. Choose from private, luxury, or group taxis for a one-way or round-trip journey. Book your hassle-free sightseeing tour to Aurangabad with 24x7 online booking support.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "5300"
        }
      };
      
     
      

    return (
        <div>
            <GTag/>

<Helmet>
        <title>Pune to Aurangabad Cab Booking | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Aurangabad cab with Mauli Cabs. Choose from affordable, private, luxury, and group taxi options for one-way or round-trip travel. Enjoy a comfortable and reliable ride with 24x7 online booking."
        />
        <meta
          name="keywords"
          content="Pune to Aurangabad cab service, Book Pune to Aurangabad taxi, Affordable Pune to Aurangabad cab, Private taxi for Aurangabad from Pune, Aurangabad trip by cab from Pune, Pune to Aurangabad one-way or round trip, Comfortable taxi ride to Aurangabad, Group travel to Aurangabad, Luxury taxi for Aurangabad trip, Aurangabad sightseeing by taxi"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/15.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default PunetoAurangabadcabbooking;